<template>
  <div
    data-app
    app-data="true"
    light>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >

      <v-row>
        <v-container
          :fluid="true"
          class="grey lighten-5"
        >

          <v-row>
            <v-col cols="8">
              <v-card>
                <v-card-title class="pb-0">
                  {{ !title ? 'Form title' : title }}
                </v-card-title>
                <v-text-field
                  v-model="title"
                  :rules="titleRules"
                  placeholder="Enter form title"
                  solo
                  class="p-1em pt-0"
                  required
                />
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card>
                <v-card-title style="padding-bottom: 11px">
                  Language
                </v-card-title>
                <div
                  class="p-1em"
                  style="text-align: center">
                  <v-btn
                    v-for="locale in locales"
                    :key="locale"
                    :class="{active: formLocale === locale, primary: formLocale === locale}"
                    class="mr-1"
                    @click="formLocale = locale"
                  >
                    {{ locale }}
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="8">
              <v-card class="p-1em">
                <v-card-title class="pt-0 pl-0">Form Fields</v-card-title>

                <draggable
                  v-model="formFields[formLocale]"
                  tag="v-card"
                >
                  <v-flex
                    v-for="(row, rowIndex) in formFields[formLocale]"
                    :key="row.index"
                    xs12
                    class="form-field-row"
                  >
                    <template v-if="formFields[formLocale].length !== 0">


                      <draggable
                        :list="row.items"
                        :group="{ name: 'row', put: row.items.length < 2 }"
                        tag="v-layout"
                        class="row-layer"
                      >
                        <v-flex
                          v-for="(item, itemIndex) in row.items"
                          :key="item.name"
                        >
                          <field
                            :item="item"
                            :item-index="itemIndex"
                            :row-index="rowIndex"

                            @removeItem="removeItem(itemIndex, rowIndex)"
                          />
                        </v-flex>
                        <v-btn
                          class="mx-2 remove-layer"
                          fab
                          small
                          color="btn btn-danger"
                          @click="removeLayer(rowIndex)"
                        >
                          <i class="fa fa-minus"/>
                        </v-btn>
                      </draggable>
                    </template>
                  </v-flex>

                </draggable>

                <v-row style="justify-content: center">
                  <v-btn
                    color="btn btn-primary"
                    fab
                    light
                    @click="createRow()"
                  >
                    <i class="fa fa-plus"/>
                  </v-btn>
                </v-row>

              </v-card>
            </v-col>

            <v-col cols="4">
              <v-card class="mb-3">
                <v-card-title class="pb-0">
                  Basic Fields
                </v-card-title>
                <draggable
                  :list="basicFields"
                  :group="{ name: 'row', pull: 'clone', put: false }"
                  :clone="clone"
                  class="list-group p-1em"
                >
                  <div
                    v-for="element in basicFields"
                    :key="element.name"
                    class="list-group-item"
                  >
                    {{ element.fieldName }}
                  </div>
                </draggable>
              </v-card>

              <v-card>
                <v-card-title class="pb-0">
                  Categories
                </v-card-title>

                <div class="p-1em">
                  <div>
                    <div
                      class="v-card__title p-0"
                      style="font-size: 1em;">
                      Value consists of:
                    </div>
                  </div>
                  <div class="options">
                    <div>
                      <label>
                        <input
                          v-model="valueConsistsOf"
                          type="radio"
                          value="ALL">
                        All
                      </label>
                    </div>
                    <div>
                      <label>
                        <input
                          v-model="valueConsistsOf"
                          type="radio"
                          value="BRANCH_PRIORITY">
                        Branch priority
                      </label>
                    </div>
                    <div>
                      <label><input
                        v-model="valueConsistsOf"
                        type="radio"
                        value="LEAF_PRIORITY">
                        Leaf priority
                      </label>
                    </div>
                    <div>
                      <label>
                        <input
                          v-model="valueConsistsOf"
                          type="radio"
                          value="ALL_WITH_INDETERMINATE">
                        All with indeterminate
                      </label>
                    </div>
                  </div>
                </div>

                <tree-select
                  v-model="categories_id"
                  :options="options"
                  :multiple="true"
                  :value-consists-of="valueConsistsOf"
                  class="p-1em"
                />
              </v-card>
            </v-col>
          </v-row>

        </v-container>

      </v-row>

      <v-row>

        <v-btn
          id="formConfig"
          :data-config="JSON.stringify(formFields[formLocale])"
          color="btn-primary btn"
          class="mr-2"
          @click="copyFieldsToClipboard"
        >
          Copy form configuration
        </v-btn>

        <v-btn
          color="btn-primary btn"
          class="mr-2"
          @click="showConfigArea = !showConfigArea"
        >
          {{ !showConfigArea ? 'Paste configuration' : 'Hide configuration' }}
        </v-btn>

        <v-btn
          v-if="debug"
          color="btn-primary btn"
          class="mr-2"
          @click="setFormData"
        >
          setFormData
        </v-btn>

      </v-row>

      <transition name="fade">
        <v-row v-if="showConfigArea">
          <v-textarea
            v-model="formFieldsModel"
            @change="formFieldsModelFunc"/>
        </v-row>
      </transition>

      <rawDisplayer
        v-if="false"
        :value="title"
        class="col-12"
        title="title"/>
      <rawDisplayer
        v-if="false"
        :value="options"
        class="col-12"
        title="options"/>
      <rawDisplayer
        v-if="debug"
        :value="errors"
        class="col-12"
        title="errors"/>
      <rawDisplayer
        v-if="debug"
        :value="globalItemID"
        class="col-12"
        title="globalItemID"/>
      <rawDisplayer
        v-if="debug"
        :value="globalRowID"
        class="col-12"
        title="globalRowID"/>
      <rawDisplayer
        v-if="debug"
        :value="categories_id"
        class="col-12"
        title="categories"/>
      <rawDisplayer
        v-if="debug"
        :value="formLocale"
        class="col-12"
        title="formLocale"/>
      <rawDisplayer
        v-if="debug"
        :value="formFields"
        class="col-12"
        title="formFields"/>

      <v-row class="mt-5">
        <v-flex xs12>

          <v-btn
            :disabled="!valid"
            color="primary"
            class="mr-2"
            @click="submit"
          >
            Save
          </v-btn>

          <v-btn
            color="btn-secondary btn"
            class="mr-2"
            @click="cancel"
          >
            Close
          </v-btn>
        </v-flex>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import ResourceFormMixin from '../mixins/ResourceFormMixin';
import Proxy from './Proxy';
import './vuetify.css'
import draggable from 'vuedraggable'
import RawDisplayer from "../components/RawDisplayer"
import Field from './fields/Field'
import FormBuilderTreeMixin from "../mixins/FormBuilderTreeMixin";

export default {
  name: 'FormBuilder',

  components: {
    draggable,
    RawDisplayer,
    Field
  },

  mixins: [ResourceFormMixin, FormBuilderTreeMixin],
  data() {
    return {
      debug: false,
      valid: true,
      valueConsistsOf: 'LEAF_PRIORITY',
      globalItemID: 100, //this property should be more than biggest id in basicFields and formFields
      globalRowID: 0, //this property should be more than biggest index in row
      formFields: {},
      formFieldsModel: '',
      categories_id: [],
      title: '',
      titleRules: [
        v => !!v || 'Title can not be empty',
      ],
      formLocale: '',
      locales: {},
      basicFields: [
        {
          name: "textfield",
          id: 1,
          fieldName: 'Textfield'
        },
        {
          name: "file",//upload file (pnd,jpg,pdf,doc,xls,zip,rar) limit 2mb
          id: 2,
          fieldName: 'File'
        },
        {
          name: "checkboxes",
          id: 3,
          fieldName: 'Checkboxes'
        },
        {
          name: "radio",
          id: 4,
          fieldName: 'Radio buttons'
        },
        {
          name: "dropdown",
          id: 5,
          fieldName: 'Select (dropdown)'
        },
        {
          name: "textarea",
          id: 6,
          fieldName: 'Textarea'
        },
      ],
      showConfigArea: false,
    };
  },

  created() {
    let load = this.loadForm(Proxy);

    load.then(() => {
      return this.fetchLanguages()
    }).then(locales => {
      let firstLocale = false
      locales.data.forEach(locale => {

        if (!firstLocale) {
          this.formLocale = locale.locale
          firstLocale = true
        }
        this.$set(this.locales, locale.locale, locale.locale)
        this.$set(this.formFields, locale.locale, [])
      })

      this.load()
    })
  },

  methods: {
    validate() {
      this.$refs.form.validate()
    },
    fetchLanguages() {
      return this.$http.get('/translations/locales');
    },
    load() {
      this.title = this.model.title
      switch (this.model.formFields) {
        case null:
          break
        default:
          this.formFields = this.objectDecode(this.model.formFields)
          for (let fields in this.formFields) {

            let _fields = this.formFields[fields]
            if (_fields.length === 0) continue

            //find biggest row id
            _fields.forEach(row => {

              if (this.globalRowID < row.index) this.globalRowID = row.index

              if (row.items.length === 0) return

              row.items.forEach(item => {
                //find biggest item id
                if (this.globalItemID < item.id) this.globalItemID = item.id
              })

            })


          }
      }

      this.categories_id = this.model.categories_id

      //allow to edit its own categories
      if (this.options && this.categories_id) {
        for (var category in this.options) {
          if (this.categories_id.indexOf(this.options[category].id) > -1) {
            this.options[category].isDisabled = false
          }

          if (this.options[category].children.length > 0) {
            for (var child in this.options[category].children) {
              if (this.categories_id.indexOf(this.options[category].children[child].id) > -1) {
                this.options[category].children[child].isDisabled = false
              }
            }
          }
        }
      }

    },
    formFieldsModelFunc() {
      try {
        this.formFields[this.formLocale] = JSON.parse(this.formFieldsModel)
      } catch (e) {
        //alert('wrong object')
      }
    },
    clone(field) {
      this.globalItemID++
      let id = this.globalItemID
      return {
        id: id,
        name: `${field.name} ${id}`,
        type: field.name,
        title: '',
        isRequired: false,
      };
    },
    createRow() {
      this.globalRowID++
      let id = this.globalRowID
      this.formFields[this.formLocale].push({
        index: id,
        items: []
      })
    },
    removeLayer(index) {
      this.formFields[this.formLocale].splice(index, 1);
    },
    removeItem(index, rowIndex) {
      this.formFields[this.formLocale][rowIndex].items.splice(index, 1);
    },
    submit() {
      this.setFormData()
      this.validate()
      if (this.valid)
        this.save(Proxy).then(() => {
          this.$toast.success('Form was saved successfully');
        })
    },
    copyFieldsToClipboard() {

      var text = document.getElementById('formConfig').dataset.config
      var listener = function (ev) {
        ev.clipboardData.setData("text/plain", text)
        ev.preventDefault()
      }
      document.addEventListener("copy", listener)
      document.execCommand("copy")
      document.removeEventListener("copy", listener)

    },
    setFormData() {
      this.model.title = this.title
      this.model.formFields = this.objectEncode(this.formFields)
      this.model.categories_id = this.categories_id
    },
    objectEncode(obj) {
      return encodeURI(JSON.stringify(obj))
    },
    objectDecode(obj) {
      return JSON.parse(decodeURI(obj))
    }
  },
}
</script>

<style>

.pt-0 {
  padding-top: 0;
}

.pl-0 {
  padding-top: 0;
}

.p-1em {
  padding: 1em !important;
}

.v-btn {
  outline: none;
}

.form-field-row {
  background: gray;
}

.v-btn--fab.v-size--small {
  height: 25px;
  width: 25px;
}

.row-layer {
  position: relative;
  padding-right: 45px;
}

.remove-layer {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
}

.layout.row-layer {
  min-height: 80px;
}

.text-align-right {
  text-align: right;
}

.list-group-item.sortable-chosen.sortable-ghost {
  flex: 1;
}

.layout.row-layer .flex:nth-last-child(2) + .flex {
  max-width: 50%;
}

.layout.row-layer > .flex:first-child:nth-last-child(n + 3),
.layout.row-layer > .flex:first-child:nth-last-child(n + 3) ~ .flex {
  max-width: 50%;
}

.primary {
  background: var(--primary) !important;
}

</style>
